// ═══════════════════════════════════════════════════════════════════════════════
// CustomerHoldingPage — full-viewport screen for customer-role users.
//
// Shown in two situations:
//   • pending  — the external guest isn't attached to any customer space yet;
//                a pending-access request has been recorded and Patriot admins
//                will approve it. No app chrome, no internal data.
//   • resolved — the guest belongs to a customer space but the customer portal
//                view hasn't shipped yet (PR3). Same screen, softer copy.
//
// Deliberately mirrors AuthSplash styling: zero sidebar/nav/data so nothing
// internal can ever leak to a customer account.
// ═══════════════════════════════════════════════════════════════════════════════
import { CSSProperties } from 'react';

export function CustomerHoldingPage({ pending, name }: { pending: boolean; name?: string }) {
  const containerStyle: CSSProperties = {
    position: 'fixed',
    inset: 0,
    zIndex: 2147483647,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    background: '#080c14',
    color: '#94a3b8',
    padding: 24,
    textAlign: 'center',
  };

  return (
    <div style={containerStyle} role="status" aria-label="Customer portal pending">
      {/* Official mark — reversed (light) color variant straight on the dark
          background, no plate. */}
      <img src="/brand/mxdr365-mark-light.png" alt="MXDR365" width={72} style={{ display: 'block', height: 'auto' }} />
      <div style={{ fontSize: 18, fontWeight: 700, color: '#e2e8f0' }}>
        {name ? `Welcome, ${name}` : 'Welcome'}
      </div>
      <div style={{ fontSize: 13, maxWidth: 420, lineHeight: 1.6 }}>
        {pending ? (
          <>
            Your customer portal is being set up. Patriot has been notified and
            will activate your access shortly — no further action is needed on
            your side. Check back soon.
          </>
        ) : (
          <>
            Your access is confirmed. Your customer portal is being prepared
            and will appear here the next time you sign in once it goes live.
          </>
        )}
      </div>
      <a
        href="/logout"
        style={{
          marginTop: 8,
          fontSize: 12,
          color: '#4a8fe2',
          textDecoration: 'none',
        }}
      >
        Sign out
      </a>
    </div>
  );
}
